import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentSolidCard } from './solid-card/component';
import { ComponentMenuBar } from './menu-bar/component';

import { AppPipesModule } from '../pipes/index.module'
import {ComponentButton} from './button/component.button';
import {ComponentProgressBar} from './progress-bar/component.progressBar';
import {ComponentDatestates} from './date-states/component.dateStates';
import {ComponentApproach} from './approach/component.approach';
@NgModule({
  imports: [CommonModule,AppPipesModule],
  declarations: [
    ComponentSolidCard,
    ComponentMenuBar,
    ComponentButton,
    ComponentProgressBar,
    ComponentApproach,
    ComponentDatestates
  ],
  exports: [
    ComponentSolidCard,
    ComponentMenuBar,
    ComponentButton,
    ComponentProgressBar,
    ComponentApproach,
    ComponentDatestates
  ]
})
export class SharedUIModule { }



// WEBPACK FOOTER //
// ./src/component-ui/index.ts